import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import { PageName } from '../../shared/types';

type Props = {
  pageName: PageName;
};

const ExcludeStrongNoScoresCheckbox = ({ pageName }: Props) => {
  const { watch, setValue } = useFormContext();
  const noStrongNoScores: boolean = watch('no_strong_no_scores');

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  return (
    <Checkbox
      data-provides={`talent-${pageName}-no-strong-no-checkbox`}
      checked={noStrongNoScores}
      onChange={(checked) =>
        setValue('no_strong_no_scores', checked, { shouldDirty: true })
      }
      label={t('no_strong_no_scores')}
      value={'no_strong_no_scores'}
    />
  );
};

export default ExcludeStrongNoScoresCheckbox;
